import {Inspection} from './inspection';

export class TailCharge {
    id: number;
    number: number;
    comment: string;
    inspection_id: number;
    inspection: Inspection;
}
